import { render, staticRenderFns } from "./Blockchain.vue?vue&type=template&id=76e22921&"
import script from "./Blockchain.vue?vue&type=script&lang=ts&"
export * from "./Blockchain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports